'use client'

// Avoid importing components that might use hooks inappropriately during static generation
// import { Button } from '@/components/ui/button'
// import { AlertTriangle } from 'lucide-react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Keep the console error but no other hooks
  // That might cause issues during static site generation
  if (typeof window !== 'undefined') {
    console.error(error)
  }

  return (
    <div className="container py-12">
      <div className="mx-auto max-w-xl text-center">
        <div className="flex justify-center mb-6">
          {/* Replace with a simple SVG instead of Lucide component */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="h-12 w-12 text-red-500"
          >
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
            <path d="M12 9v4"></path>
            <path d="M12 17h.01"></path>
          </svg>
        </div>
        <h2 className="text-2xl font-bold mb-4">Something went wrong!</h2>
        <p className="text-neutral-600 dark:text-neutral-400 mb-6">
          We apologize for the inconvenience. Please try again or contact us if the problem persists.
        </p>
        <button 
          onClick={() => reset()}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >
          Try again
        </button>
      </div>
    </div>
  )
} 